import { render, staticRenderFns } from "./DelVideoModal.vue?vue&type=template&id=7b94e086&scoped=true"
import script from "./DelVideoModal.vue?vue&type=script&lang=ts"
export * from "./DelVideoModal.vue?vue&type=script&lang=ts"
import style0 from "./DelVideoModal.vue?vue&type=style&index=0&id=7b94e086&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b94e086",
  null
  
)

export default component.exports